<template>
  <div>
    <v-container>
      <v-row>
        <h2 class="pb-4 pt-2">Ersatzzüge</h2>
      </v-row>
      <v-row>
        <v-col cols="12">
          <AnonymousNotice />
        </v-col>
      </v-row>

      <template v-if="history">
        <v-row>
          <v-col cols="12">
            <div style="height: 400px">
              <LineChart :datasets="datasets" :labels="labels" :options="options"/>
            </div>
          </v-col>
        </v-row>
      </template>
      <LoadingIndicator v-else/>
    </v-container>
  </div>
</template>

<script>
import has from 'lodash/has';
import uniq from 'lodash/uniq';
import AnonymousNotice from '@/components/AnonymousNotice.vue'
import LineChart from '@/components/LineChart.vue'
import LoadingIndicator from '@/components/LoadingIndicator.vue'
import TitleMixin from '@/mixins/TitleMixin'
import { chartColor } from '@/utils/chartColors'

export default {
  name: 'ReplacementTrainHistory',

  mixins: [TitleMixin],

  components: {
    AnonymousNotice,
    LineChart,
    LoadingIndicator,
  },

  computed: {
    title: function() {
      return `Ersatzzüge - ${import.meta.env.VITE_NAME}`;
    },
  },

  data: () => ({
    datasets: null,
    err: null,
    history: null,
    labels: null,
    options: {
      maintainAspectRatio: false,
      scales: {
        x: {
          stacked: true
        },
        y: {
          stacked: true
        }
      }
    },
    trainCategories: [
      'ICE',
      'IC',
      'EC',
    ],
  }),

  methods: {
    getDatasets: function(history, labels) {
      var result = this.trainCategories.map((key, index) => {
        var replacementTrainHistory = history[key];
        var values = [];

        labels.forEach(label => {
          if (has(replacementTrainHistory, label)) {
            values.push(replacementTrainHistory[label]);
          } else {
            values.push(0);
          }
        });

        var color = chartColor(index);
        return {
          label: key,
          data: values,
          pointRadius: 1,
          borderColor: color,
          backgroundColor: color,
          fill: true,
        };
      });

      this.$log.debug(result);
      return result;
    },

    getLabels: function(history) {
      var rawLabels = [];
      Object.keys(history).forEach(function(category) {
        rawLabels = rawLabels.concat(Object.keys(history[category]));
      });
      return uniq(rawLabels);
    },

    getReplacementTrainHistory: function() {
      this.datasets = null;
      this.err = null;
      this.history = null;
      this.labels = null;

      this.$log.info("Retrieving replacement train history");

      this.$api
        .get(`/train/replacement`)
        .then(response => {
          this.history = response.data;
          this.labels = this.getLabels(this.history);
          this.$log.debug(this.labels)
          this.datasets = this.getDatasets(this.history, this.labels);

          this.$log.info("Finished retrieving replacement train history");
        })
        .catch(err => {
          this.err = err;
          this.$log.error(err);
        });
    },
  },

  mounted: function () {
    this.getReplacementTrainHistory()
  },
};
</script>
